import { mixpanelObject } from 'src/utils/analytics';
import { setLoginInitiatedAndReturnMixPanel } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { LINK_TYPE } from 'src/utils/constants/stringConstants';

import {
  appleLoginAPI,
  fbLoginAPI,
  fbRegisterAPI,
  googleLoginAPI,
  googleRegisterAPI
} from '../../services/apiRequests/Login/LoginService';
import SimpleStore from '../../store/SimpleStore';
import {
  getLocalStorage,
  setLocalStorage
} from '../../utils/browserStorageHandler';
import { parseJwt } from '../../utils/common';
import { HTTP_HEADER_KEYS } from '../../utils/constants/HttpMethodsConstants';
import {
  GUEST_TOKEN,
  USER_TOKEN
} from '../../utils/constants/localStorageConstants';
import {
  MIXPANEL_SOCIAL,
  MIXPANEL_FACEBOOK_LOGIN,
  MIXPANEL_APPLE_LOGIN,
  MIXPANEL_GOOGLE_LOGIN
} from '../../utils/analytics/mixpanel/mixpanelConstants';

export const SOCIAL_REGISTER_CONSENTS = {
  IsThirdPartyWatchHistoryDataSharing: true,
  IsTargetedAds: true,
  IsThirdPartyDataSharing: true,
  IsPrivacyPolicy: true,
  IsEmailNotificationEnabled: true,
  IsSMSNotificationEnabled: true,
  IsWhatsappNotificationEnabled: true,
  IsPushNotificationEnabled: true,
  ApplicationVersion: '1.0',
  PolicyVersion: '1.0',
  PlatformName: 'Android'
};

// FACEBOOK LOGIN UTILS
export const fbLogin = (onClose: () => void) => {
  if (window && window.FB) {
    setLoginInitiatedAndReturnMixPanel(
      'initiate',
      mixpanelObject,
      MIXPANEL_SOCIAL,
      MIXPANEL_FACEBOOK_LOGIN
    );
    window.FB.login((result: any) => {
      if (result?.authResponse?.accessToken) {
        const facebookToken = result.authResponse.accessToken;
        const reqObj = {
          access_token: facebookToken
        };
        fbLoginAPI(reqObj)
          .then((loginData) => {
            if (loginData.access_token) {
              setLocalStorage(USER_TOKEN, loginData.access_token);
              SimpleStore.set(
                HTTP_HEADER_KEYS.AUTHORIZATION,
                loginData.access_token
              );
              onClose();
            }
            if (loginData.code === 2) {
              //user not registered with Zee5
              const reqObjRegister = {
                token: facebookToken,
                ...SOCIAL_REGISTER_CONSENTS
              };
              fbRegisterAPI(reqObjRegister).then((registerData) => {
                if (registerData.access_token) {
                  setLocalStorage(USER_TOKEN, registerData.access_token);
                  SimpleStore.set(
                    HTTP_HEADER_KEYS.AUTHORIZATION,
                    registerData.access_token
                  );
                  onClose();
                }
              });
            }
          })
          .catch((err) => console.error('FB login API error', err));
      }
    });
  }
};

//APPLE LOGIN FUNCTION
export const appleLogin = async (onClose: () => void) => {
  const response = await window.AppleID?.auth?.signIn();
  try {
    setLoginInitiatedAndReturnMixPanel(
      'initiate',
      mixpanelObject,
      MIXPANEL_SOCIAL,
      MIXPANEL_APPLE_LOGIN
    );
    const reqObj: any = {
      guest_token: getLocalStorage(GUEST_TOKEN),
      platform: 'apple_app',
      idfa: '',
      appsflyer_id: '',
      userIdentifier: '',
      version: '2.0.1'
    };
    if (response && response.authorization) {
      reqObj.token = response.authorization.id_token;
      reqObj.access_token = response.authorization.id_token;
      reqObj.email = parseJwt(response.authorization.id_token).email;
    }
    const data = await appleLoginAPI(reqObj);
    if (data.access_token) {
      setLocalStorage(USER_TOKEN, data.access_token);
      SimpleStore.set(HTTP_HEADER_KEYS.AUTHORIZATION, data?.access_token);
      onClose();
    }
  } catch (error) {
    console.error('Apple login API error: ', error);
  }
};

//GOOGLE LOGIN
export const googleLogin = (onClose: () => void) => {
  if (window && window.gapi && window.auth2) {
    const element = document.getElementById('gbtn');
    setLoginInitiatedAndReturnMixPanel(
      'initiate',
      mixpanelObject,
      MIXPANEL_SOCIAL,
      MIXPANEL_GOOGLE_LOGIN
    );
    window.auth2.attachClickHandler(
      element,
      {},
      () => {
        const googleToken = window.gapi.auth2
          .getAuthInstance()
          .currentUser.get()
          .getAuthResponse(true).access_token;
        const reqObj = {
          access_token: googleToken
        };
        //GOOGLE Login API call
        googleLoginAPI(reqObj)
          .then((loginData) => {
            if (loginData.access_token) {
              setLocalStorage(USER_TOKEN, loginData.access_token);
              SimpleStore.set(
                HTTP_HEADER_KEYS.AUTHORIZATION,
                loginData.access_token
              );
              onClose();
            }
            if (loginData.code === 2) {
              //user not registered with Zee5
              const reqObjRegister = {
                token: googleToken
                // ...SOCIAL_REGISTER_CONSENTS
              };
              googleRegisterAPI(reqObjRegister).then((registerData) => {
                if (registerData.access_token) {
                  setLocalStorage(USER_TOKEN, registerData.access_token);
                  SimpleStore.set(
                    HTTP_HEADER_KEYS.AUTHORIZATION,
                    registerData.access_token
                  );
                  onClose();
                }
              });
            }
          })
          .catch((err) => console.error('Google login API error', err));
      },
      (error: any) => {
        console.error(error);
      }
    );
  }
};

interface OpenWindow {
  url: string;
  name?: string;
}

export const openWindow = ({ url, name }: OpenWindow) => {
  const top = (window.innerHeight - 400) / 2 + window.screenY;
  const left = (window.innerWidth - 400) / 2 + window.screenX;

  return window.open(
    url,
    name,
    `dialog=yes,top=${top}px,left=${left},width=${400}px,height=${500}px`
  );
};

interface ObserveWindow {
  popup: Window;
  interval?: number;
  onClose: () => void;
}

export const observeWindow = ({ popup, interval, onClose }: ObserveWindow) => {
  const intervalId = setInterval(() => {
    if (popup.closed) {
      clearInterval(intervalId);
      onClose();
    }
  }, interval || 100);
};
